import { useQuery } from '@tanstack/react-query';

import {
  partnersEventsApi,
  partnersEventsApiKeys,
} from '@/api/routes/partners/partners.events.api';

/** One event with counts and history; idle until there is an id (the create form has none). */
export const usePartnersReadEvent = (id?: string) => {
  return useQuery({
    queryKey: partnersEventsApiKeys.detail(id ?? ''),
    queryFn: () => partnersEventsApi.read(id as string).then((res) => res.data.event),
    enabled: Boolean(id),
  });
};
